import React from 'react'
import DatePicker, { DatePickerProps, registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import './Calendar.css' // Archivo para tus estilos personalizados
import es from 'date-fns/locale/es'
registerLocale('es', es)

export default function Calendar(props: DatePickerProps) {
    return (
        <div className="customDatePickerWidth">
            <DatePicker {...props} inline locale="es" />
        </div>
    )
}
